/** @format */
import { Image } from 'antd';

export default function CustomImage(props) {
	return <Image preview={false} {...props} />;
}
